import React, { type FC, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useAtom } from 'jotai'
import { useAtomCallback } from 'jotai/utils'

import {
  Group,
  InputText,
  Item,
  Panel,
  SearchForm,
} from 'mailup-web-components'

import { categoriesQueryAtom } from '../state/state'
import {
  changeCategoriesQueryAndSearch,
  resetCategoriesQueryAndSearch,
} from '../callbacks/categories'
import { gainsightTrack } from 'mailup-react-helpers'

const Search: FC = () => {
  const intl = useIntl()
  const [query, setQuery] = useAtom(categoriesQueryAtom)
  const handleSearch = useAtomCallback(
    useCallback(async (get, set) => {
      gainsightTrack('mup_recipients_click_filtersCategoriesSearchByName', {
        commercialOfferName: 'mup',
        searchWithTextInputCategory: query.name !== ""
      })

      await changeCategoriesQueryAndSearch(get, set, { pageNumber: 1 })
    }, []),
  )
  const handleReset = useAtomCallback(resetCategoriesQueryAndSearch)

  return (
    <Panel data-mu-test='search-panel' margin='0'>
      <SearchForm
        advanced={false}
        labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
        labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
        onSubmit={handleSearch}
        onClickReset={handleReset}
      >
        <Group>
          <Item>
            <InputText
              name='name'
              placeholder={intl.formatMessage({
                id: 'Load.FiltersCategories.InputNamePlaceholder',
              })}
              value={query.name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setQuery((q) => {
                  return { ...q, name: e.target.value }
                })
              }}
            />
          </Item>
        </Group>
      </SearchForm>
    </Panel>
  )
}

export default Search
